import './Loader.css'
import logo from '../App/logo192.png'

export default function Loader () {
  return(
    <div className="loader">
      <img className="App-logo" src={logo} alt="spinner"/> 
    </div>
     
  )
}